import React, { useEffect, useRef, useState } from "react";
import Loading from "../Modals/Loading";
import scannedItemsService from "../Services/scannedItemsService";
import {
  MdKeyboardDoubleArrowDown,
  MdKeyboardDoubleArrowUp,
} from "react-icons/md";

const ScannedProducts = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [scannedItems, setScannedItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const topRef = useRef(null);
  const bottomRef = useRef(null);

  useEffect(() => {
    const getScannedItems = async () => {
      try {
        setLoading(true);
        const response = await scannedItemsService.fetchAll(); // calls your API
        if (response && response.scanneditems) {
          setScannedItems(response.scanneditems);
        }
      } catch (error) {
        console.error("Error fetching scanned items:", error.message);
      } finally {
        setLoading(false);
      }
    };

    getScannedItems();
  }, []);

  // Filter scanned items based on search input (part number starts with searchTerm)
  const filteredItems = scannedItems.filter((item) =>
    item.part_number.toLowerCase().startsWith(searchTerm.toLowerCase()),
  );

  // Total Quantity based on filtered items
  const totalQuantity =
    filteredItems.reduce(
      (sum, item) => sum + (Number(item.quantity) || 0),
      0,
    ) || 0;

  return (
    <main className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg mb-20 bg-white">
      <div ref={topRef} />
      <div className="flex flex-row justify-between items-start">
        <h1 className="font-bold text-3xl text-secondary mb-4">Packing List</h1>
        <input
          type="text"
          placeholder="Search by Part Number"
          value={searchTerm}
          onFocus={(e) => e.target.select()} // Auto-select all text on focus
          onChange={(e) => setSearchTerm(e.target.value)}
          className="primary-input !w-[400px]"
        />
      </div>
      {loading ? (
        <Loading />
      ) : (
        <div>
          <div className="fixed bottom-10 right-10 flex flex-col gap-3 z-50">
            <button
              onClick={() =>
                topRef.current?.scrollIntoView({ behavior: "smooth" })
              }
              className="w-11 h-11 flex items-center justify-center rounded-full bg-white border border-gray-200 shadow-lg hover:shadow-xl hover:bg-gray-50 hover:-translate-y-1 transition-all duration-300 group"
              title="Scroll to Top"
            >
              <MdKeyboardDoubleArrowUp className="text-xl text-gray-600 group-hover:text-gray-900 transition-colors duration-300" />
            </button>
            <button
              onClick={() =>
                bottomRef.current?.scrollIntoView({ behavior: "smooth" })
              }
              className="w-11 h-11 flex items-center justify-center rounded-full bg-white border border-gray-200 shadow-lg hover:shadow-xl hover:bg-gray-50 hover:translate-y-1 transition-all duration-300 group"
              title="Scroll to Bottom"
            >
              <MdKeyboardDoubleArrowDown className="text-xl text-gray-600 group-hover:text-gray-900 transition-colors duration-300" />
            </button>
          </div>
          {/* Table */}
          {filteredItems && filteredItems.length > 0 ? (
            <div className="table-div">
              <table className="w-full">
                <thead className="border-y-2 text-center text-black text-[10px]">
                  <tr>
                    <th className="py-4 w-[4%]">Sr No.</th>
                    <th className="py-4 w-[2%]">Part Number</th>
                    <th className="py-4 w-[6%]">Name</th>
                    <th className="py-4 w-[6%]">Quantity</th>
                    <th className="py-4 w-[6%]">Maker</th>
                    <th className="py-4 w-[6%]">Condition</th>
                    <th className="py-4 w-[6%]">HS Code</th>
                    <th className="py-4 w-[6%]">Location Name</th>
                    <th className="py-4 w-[6%]">Location Number</th>
                    <th className="py-4 w-[6%]">Location Type</th>
                    <th className="py-4 w-[6%]">Location Area</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredItems.map((value, index) => (
                    <tr
                      key={index}
                      className="bg-accent border-b border-gray-200 text-center text-[11px]"
                    >
                      <td className="py-4 w-[4%] font-bold text-blue-500">
                        {value.sr_no}.
                      </td>
                      <td className="py-4 w-[2%]">{value.part_number}</td>
                      <td className="py-4 font-bold w-[6%]">{value.name}</td>
                      <td className="py-4 w-[6%]">{value.quantity}</td>
                      <td className="py-4 w-[6%]">{value.maker}</td>
                      <td className="py-4 w-[6%]">{value.condition}</td>
                      <td className="py-4 font-semibold w-[6%]">
                        {value.hs_code}
                      </td>
                      <td className="py-4 w-[6%]">{value.location_name}</td>
                      <td className="py-4 w-[6%]">{value.location_number}</td>
                      <td className="py-4 w-[6%]">{value.location_type}</td>
                      <td className="py-4 w-[6%]">{value.location_area}</td>
                    </tr>
                  ))}
                  <tr className="text-[12px] text-lg bg-slate-200 font-semibold text-teal-600 pt-4">
                    <td className="py-3 pl-4 col-span-4">Total</td>
                    <td></td>
                    <td></td>
                    <td className="py-3 pl-6">{totalQuantity}</td>
                    <td></td>
                    <td className="py-3 pl-4"></td>
                    <td className="py-3 pl-4"></td>
                    <td className="py-3 pl-4"></td>
                    <td className="py-3 pl-4"></td>
                    <td className="py-3 pl-4"></td>
                    <td className="py-3 pl-4"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          ) : (
            <div className="mt-20">
              <h1 className="font-bold text-2xl text-gray-700 text-center">
                No Data Found
              </h1>
            </div>
          )}
        </div>
      )}
      <div ref={bottomRef} />
    </main>
  );
};

export default ScannedProducts;
